import useJwt from './service/useJwt'
import axios from '@axios'

const { jwt } = useJwt(axios, {})
export default jwt
